module.exports = __webpack_public_path__ + "static/media/cvapp.2c0d24fe.PNG";